<template>
  <b-overlay 
    :show="busy" 
    variant="dark"
  >
    <b-container>
      <b-input-group prepend="Aan">
        <b-input 
          v-model="recipient" 
          type="email"
        />
        <b-input-group-append>
          <b-button 
            variant="primary" 
            @click="sendHerinnering"
          >
            <font-awesome-icon icon="paper-plane" /> Verstuur herinnering
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <b-input-group prepend="Onderwerp">
        <b-input 
          v-model="subject" 
          type="text"
        />
      </b-input-group>
      
      <quill-editor
        v-model="content" 
      />
    </b-container>
  </b-overlay>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";
import { facturatieMixin } from "@/mixins/facturatieMixin";
import Vue from 'vue'
import VueQuillEditor from 'vue-quill-editor'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// mount with global
Vue.use(VueQuillEditor)

export default {
  name: 'RelatieHerinnering',
  components: {},
  mixins: [serviceMixin, facturatieMixin],
  props: {
    factuur: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      recipient: 'nordin@nosli.nl',
      busy: false,
      subject: "Herinnering openstaande factuur",
      content: null,
      defaultEmail: `Beste klant, <br><br>
      Volgens onze administratie zijn de volgende facturen nog niet, of niet volledig betaald.<br><br>

      [[factuur_details]]<br><br>

      We verzoeken je vriendelijk de facturen waarvan de vervaldatum is verstreken binnen 8 dagen te voldoen.<br><br>

      Heb je ondertussen al betaald, dan kun je dit bericht negeren. Heb je vragen over de factuur? Neem dan contact met ons op via administratie@donkenliftadvies.nl<br><br>

      Met vriendelijke groeten,<br>
      Donkenliftadvies<br>
       `
    }
  },
  computed: {
    default_content: function () {
      return this.defaultEmail.replace('[[factuur_details]]', this.factuurDetails)
    },
    factuurDetails: function () {
      return `Factuurnummer: ${this.factuur.Factuurnummer}-${this.factuur.FactuurJaar} | 
      ${this.factuur.Onderwerp} - ${this.factuur.Relatie.Naam}<br/> 
      Factuurtotaal: ${this.formattedTotaal} (vervallen op ${this.moment(this.factuur.Factuurdatum)
                    .add(30, 'days').format('LL')})`
    },
    endpoint() {
      return "/facturen/" + this.factuur.Relatie.Id + "/openstaand";
    },
    factuurTotaal: function () {
      var totaal = 0.0;
      if (this.factuur.Factuurregels) {
        this.factuur.Factuurregels.forEach((elem) => {
          totaal += elem.Aantal * elem.Bedrag;
        });
      }

      return totaal;
    },
    factuurTotaalInclBTW() {
      return (
        Number(this.factuurTotaal) *
        ((100 +
          Number(this.factuur.Details.eigenschappen.FactuurStandaardBTW)) /
          100)
      );
    },
    formattedTotaal() {
      return this.factuurTotaalInclBTW.toLocaleString("nl-NL", {
        style: "currency",
        currency: "EUR",
      });
    }
  },
  beforeMount() {
    this.$set(this, 'content', this.default_content);
    this.$set(this, 'recipient', this.factuur.VerzendenNaar);
 },
  methods: {
    sendHerinnering() {
      var vm = this;
      this.busy = true;
      var data =  {
        recipients: [this.recipient],
        subject: this.subject,
        factuurId: this.factuur.Id,
        htmlBody: this.content,
      };
      console.log(data); 
      this.$http.post(this.endpoint, data)
      .then((result) => {
        this.busy = false;
        console.log(result);
        vm.$emit('success', result);
      })
      .catch((error) => {
        this.busy = false;
        console.log(error);
        vm.$emit('error', error);
      })
    }
  }

}

</script>

